import { initialize, track, getInAppMessages, DisplayOptions, updateUser } from '@iterable/web-sdk';

import type { GenerateJWTPayload, UpdateUserParams } from '@iterable/web-sdk';

const IterableService = {
  initializeWithJWT: (
    apiKey: string,
    generateJWT: (payload: GenerateJWTPayload) => Promise<string>,
  ) => initialize(apiKey, generateJWT),

  initializeWithoutJWT: (apiKey: string) => initialize(apiKey),

  track: (eventName: string, dataFields?: Record<string, unknown>) => {
    return track({ eventName, dataFields });
  },

  /** After `setUserID`, sync profile fields (SDK sends `preferUserId: true`). */
  updateUserDataFields: (dataFields: NonNullable<UpdateUserParams['dataFields']>) => {
    return updateUser({ dataFields });
  },

  getInAppMessagesImmediate: (options: {
    count: number;
    displayInterval?: number;
    packageName: string;
  }) => {
    return getInAppMessages(options, { display: DisplayOptions.Immediate });
  },
};

export default IterableService;
